import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { styled } from "@mui/material/styles";

const LightTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: theme.palette.primary.main,
		color: "white",
		boxShadow: theme.shadows[1],
		fontSize: 12,
		lineHeight: 1.4,
		maxWidth: 320,
	},
}));

function getInstructorDisplayName(role) {
	if (!role) {
		return "";
	}

	if (typeof role.name === "string" && role.name.trim()) {
		return role.name.trim();
	}

	const lastName = role.user?.last_name?.trim();
	const firstName = role.user?.first_name?.trim();

	if (lastName || firstName) {
		return [lastName, firstName].filter(Boolean).join(", ");
	}

	return "";
}
function getInstructorNames(row) {
	return Array.isArray(row?.roles) ? row.roles.map(getInstructorDisplayName).filter(Boolean) : [];
}

const InstructorCell = ({ row, isConstrainedLayout } ) => {
	const instructorNames = getInstructorNames(row);
	const instructorCount = instructorNames.length;
	

	if (instructorCount === 0) {
		return (
			<div className="flex h-full  items-center overflow-hidden">
				<p
					className={` text-left  font-semibold text-secondaryRed ${isConstrainedLayout ? "text-[8pt] max-w-[20ch] truncate" : "text-xs"}`}
					title="No Instructor Found"
				>
					No Instructor Found
				</p>
			</div>
		);
	}

	if (instructorCount === 1) {
		const instructorName = instructorNames[0];

		return (
			<div className="flex h-full  items-center overflow-hidden ">
				<p className={`  text-left font-semibold ${isConstrainedLayout ? "text-[8pt] max-w-[20ch] truncate" : "text-xs"}`} title={instructorName}>
					{instructorName}
				</p>
			</div>
		);
	}

	const primaryInstructorName = instructorNames[0];
	const additionalInstructorCount = instructorCount - 1;

	return (
		<LightTooltip
			title={
				<div className="py-1">
					<p className={`mb-2 ${isConstrainedLayout ? "text-[8pt] max-w-[20ch] truncate" : "text-xs"} uppercase tracking-[0.12em] text-white/80`}>
						Instructors
					</p>
					<ul className="m-0 list-none p-0">
						{instructorNames.map((name, index) => (
							<li key={`${name}-${index}`} className="py-1">
								{name}
							</li>
						))}
					</ul>
				</div>
			}
			placement="top-start"
			arrow
			enterDelay={75}
			enterNextDelay={0}
			enterTouchDelay={0}
			leaveDelay={0}
			slotProps={{
				popper: {
					modifiers: [
						{
							name: "offset",
							options: {
								offset: [0, -10],
							},
						},
					],
				},
			}}
		>
			<div
				className="flex h-full w-full cursor-help items-center overflow-hidden "
				tabIndex={0}
				aria-label={`Instructors: ${instructorNames.join(", ")}`}
			>
				<p className={`min-w-0 flex-1 truncate text-left font-semibold ${isConstrainedLayout ? "text-[8pt]" : "text-xs"}`} title={primaryInstructorName}>
					{primaryInstructorName}
				</p>
				<span className="ml-2 shrink-0 rounded-full bg-primary/10 px-2 py-0.5 text-[10px] font-semibold text-primary">
					+{additionalInstructorCount}
				</span>
				<VisibilityIcon sx={{ width: 16, height: 16, marginLeft: "6px", color: "primary.main" }} />
			</div>
		</LightTooltip>
	);
};

export default InstructorCell;
